module.exports = {
	"name": "bpmn.io DI for DMN",
	"uri": "http://bpmn.io/schema/dmn/biodi/1.0",
	"prefix": "biodi",
	"xml": {
		"tagAlias": "lowerCase"
	},
	"types": [
		{
			"name": "Edge",
			"superClass": [
				"Element"
			],
			"properties": [
				{
					"name": "source",
					"type": "String",
					"isAttr": true
				},
				{
					"name": "waypoints",
					"type": "Waypoint",
					"isMany": true,
					"xml": {
						"serialize": "property"
					}
				}
			]
		},
		{
			"name": "Bounds",
			"superClass": [
				"dc:Bounds",
				"Element"
			]
		},
		{
			"name": "Waypoint",
			"superClass": [
				"dc:Point"
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/dmn-moddle/resources/dmn/bpmn-io/biodi.json
// module id = 1138
// module chunks = 1